<template>
  <editor-content :editor="editor" />
</template>

<script>
import { Extension } from '@tiptap/core';
import Document from '@tiptap/extension-document';
import Heading from '@tiptap/extension-heading';
import History from '@tiptap/extension-history';
import Placeholder from '@tiptap/extension-placeholder';
import Text from '@tiptap/extension-text';
import { EditorContent, useEditor } from '@tiptap/vue-3';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    initialContent: {
      type: String,
      default: '',
    },
    autoFocus: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Untitled',
    },
  },
  components: { EditorContent },

  emits: ['update:value'],

  setup(props, { emit }) {
    const DisableEnter = Extension.create({
      addKeyboardShortcuts() {
        return { Enter: () => true };
      },
    });

    const editor = useEditor({
      content: props.initialContent,
      extensions: [
        Document,
        Text,
        DisableEnter,
        Heading.configure({ levels: [1] }),
        History,
        Placeholder.configure({ placeholder: props.placeholder, showOnlyWhenEditable: false }),
      ],
      onUpdate: ({ editor }) => {
        emit('update:value', editor.state.doc.textContent);
      },
    });

    return { editor };
  },
  watch: {
    value(val) {
      if (val !== this.editor.state.doc.textContent) {
        this.editor.commands.setContent(val);
      }
    },
  },
  mounted() {
    if (this.autoFocus) {
      this.editor.commands.focus();
    }
    if (this.value !== '') {
      this.editor.commands.setContent({
        type: 'doc',
        content: [
          {
            type: 'heading',
            attrs: { level: 1 },
            content: [{ type: 'text', text: this.value }],
          },
        ],
      });
    }
  },
  beforeUnmount() {
    this.editor.destroy();
  },
};
</script>

<style type="text/scss">
.ProseMirror p.is-editor-empty:first-child::before {
    content: attr(data-placeholder);
    float: left;
    color: map_get($grey, 'lighten-4');
    pointer-events: none;
    height: 0;
}
</style>
